'use strict';

(function (root, factory) {
    if (typeof module !== 'undefined' && module.exports !== undefined) {
        module.exports = factory(root);
    } else if (typeof define !== 'undefined' && define.amd) {
        define('iSessionStorage', [], function () {
            return factory(root);
        });
    } else {
        root.iSessionStorage = factory(root);
    }
})(window || module || {}, function (root) {
    return {
        '_storage': root.sessionStorage,

        /**
         *
         * @return {boolean}
         */
        'isSupported': function isSupported() {
            return !!this._storage;
        },

        /**
         *
         * @param name
         * @param value
         * @return {boolean}
         */
        'set': function set(name, value) {
            if (!name || !this._storage) {
                return false;
            }

            try {
                this._storage.setItem(name, value);
                return !!this._storage.getItem(name);
            } catch (e) {
                return value;
            }
        },

        /**
         *
         * @param {string} name
         * @return {*}
         */
        'get': function get(name) {
            if (!name || !this._storage) {
                return null;
            }

            return this._storage.getItem(name);
        },

        /**
         *
         * @param {string} name
         * @return {boolean}
         */
        'remove': function remove(name) {
            if (!name || !this._storage) {
                return false;
            }

            this._storage.removeItem(name);

            return true;
        },

        /**
         *
         * @return {boolean}
         */
        'clear': function clear() {
            if (!this._storage) {
                return false;
            } else {
                return this._storage.clear();
            }
        }
    };
});